var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29 4.04a.65.65 0 0 1 .92 0l3.5 3.5a.65.65 0 0 1 0 .92l-3.5 3.5a.65.65 0 0 1-.92-.92L9.33 8 6.29 4.96a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};
export default SvgChevronRight;